import List from "./List";
import Filter from "./Filter";
import Info from "./Info";
export default {
    List,
    Filter,
    Info
}